import { useEffect } from "react";
import {
    addHexagonsToMap,
    addHexagonInteractivity,
} from "../utils/hexagonUtils";

export const useHexagonManagement = ({
    mapInstance,
    showHexagons,
    hexagonConfig,
    points,
    memoizedHexagons,
    handleMarkerClick,
}) => {
    const cleanupHexagonLayers = (map) => {
        try {
            if (map.getLayer("hexagons-labels")) {
                map.removeLayer("hexagons-labels");
            }
            if (map.getLayer("hexagons-outline")) {
                map.removeLayer("hexagons-outline");
            }
            if (map.getLayer("hexagons-layer")) {
                map.removeLayer("hexagons-layer");
            }
            if (map.getSource("hexagons")) {
                map.removeSource("hexagons");
            }
        } catch (error) {
        }
    };

    useEffect(() => {
        if (!mapInstance || !showHexagons || points.length === 0) return;

        const checkAndAddHexagons = () => {
            if (
                mapInstance &&
                mapInstance.isStyleLoaded &&
                mapInstance.isStyleLoaded()
            ) {
                addHexagonsToMap(mapInstance, memoizedHexagons, (map) =>
                    addHexagonInteractivity(map, handleMarkerClick)
                );
            } else if (mapInstance) {
                setTimeout(checkAndAddHexagons, 200);
            }
        };

        setTimeout(checkAndAddHexagons, 300);
    }, [
        showHexagons,
        hexagonConfig,
        points,
        mapInstance,
        memoizedHexagons,
        handleMarkerClick,
    ]);

    return {
        cleanupHexagonLayers,

        reAddHexagons: () => {
            if (mapInstance && showHexagons && points.length > 0) {
                addHexagonsToMap(mapInstance, memoizedHexagons, (map) =>
                    addHexagonInteractivity(map, handleMarkerClick)
                );
            }
        },

        toggleHexagonVisibility: (visible) => {
            if (!mapInstance) return;

            if (visible && points.length > 0) {
                addHexagonsToMap(mapInstance, memoizedHexagons, (map) =>
                    addHexagonInteractivity(map, handleMarkerClick)
                );
            } else {
                cleanupHexagonLayers(mapInstance);
            }
        },
    };
};
